import { render, staticRenderFns } from "./TemplateSelector.vue?vue&type=template&id=4cdf91c9&"
import script from "./TemplateSelector.vue?vue&type=script&lang=js&"
export * from "./TemplateSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports